import type { DocumentModel } from '@ctw/shared/api/fhir/models/document';
import { LazyDocumentViewer } from '@ctw/shared/context/_internal/resource/resource-actions/resource-modal-actions/lazy-document-viewer';
import type { UseResourceModalOpenModalArgs } from '@ctw/shared/context/resource-modal-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const documentReferenceModalAction: UseResourceModalOpenModalArgs<'DocumentReference'>['action'] =
  ({ model, closeModal }) => ({
    label: 'Document',
    title: model.title,
    content: {
      body: <DocumentReferenceModalContent documentReference={model} closeModal={closeModal} />,
    },
  });

interface DocumentReferenceModalContentProps {
  documentReference: DocumentModel;
  closeModal: () => void;
}

const DocumentReferenceModalContent = ({
  documentReference,
  closeModal,
}: DocumentReferenceModalContentProps) => {
  return (
    <div className={tw`flex h-full max-h-screen w-full flex-col items-center`}>
      <LazyDocumentViewer
        documentReference={documentReference}
        onClose={closeModal}
        controls={{
          search: true,
          close: true,
          download: true,
          print: true,
          openInNewTab: true,
          deepLinkSections: true,
        }}
      />
    </div>
  );
};
